import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  constructor() { }

  /**
   * Get a response from the AI assistant
   * @param message The user's message
   * @returns An Observable that emits the AI's response
   */
  getAIResponse(message: string): Observable<string> {
    // In a real implementation, this would call an API to get a response from an AI service
    // For now, we'll simulate a response with a delay
    
    let response = 'I understand your question. Let me think about that...';
    
    // Simple response logic based on user input
    if (message.toLowerCase().includes('hello') || message.toLowerCase().includes('hi')) {
      response = 'Hello! How can I assist you today?';
    } else if (message.toLowerCase().includes('help')) {
      response = 'I can help you with information about the platform, answer questions, or provide guidance. What do you need help with?';
    } else if (message.toLowerCase().includes('thank')) {
      response = 'You\'re welcome! Is there anything else I can help you with?';
    } else if (message.toLowerCase().includes('training') || message.toLowerCase().includes('course')) {
      response = 'We have various training courses available. You can find them in the Training section. Would you like me to help you find a specific course?';
    } else if (message.toLowerCase().includes('certificate') || message.toLowerCase().includes('certification')) {
      response = 'Certificates are awarded upon successful completion of courses. You can view your certificates in the Profile section.';
    } else if (message.toLowerCase().includes('password') || message.toLowerCase().includes('login')) {
      response = 'For password or login issues, please visit the Settings section or contact your administrator.';
    } else {
      response = 'Thank you for your message. I\'m here to help. Could you provide more details about what you\'re looking for?';
    }
    
    // Simulate network delay
    return of(response).pipe(delay(1500));
  }
}